import { createRenderBatcher } from './basler-components.es777.js';

const { schedule: microtask} = 
/* @__PURE__ */ createRenderBatcher(queueMicrotask, false);

export { microtask };
